import { CircularProgress } from '@mui/material'
import React from 'react'

const Loader = () => {
    return (
        <div className="absolute left-[50%] top-[50%]">
            <CircularProgress sx={{color:"#EF5a24"}}/>
        </div>
    )
}

export default Loader